module.exports = __webpack_public_path__ + "img/square.be5030ca.webp";